import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import PageNotFound from "../modules/organization-setup/page-not-found";

const ProtectedRoute = ({ children, restrictedTo }) => {
  const location = useLocation();
  const path = location.pathname;

  const credential = JSON.parse(localStorage.getItem("credential") || "null");
  const isLoggedIn = Boolean(credential);
  const isActive = credential?.active;
  const isOnboardingCompleted = credential?.is_onboarding_completed;
  const userRole = credential?.role;

  if (!isLoggedIn) {
    if (path !== "/auth/login") {
      return <Navigate to="/auth/login" replace />;
    }
    return children;
  }

  // 2. Logged in, but NOT active → only allow /plan-expired
  if (!isActive) {
    if (path !== "/plan-expired") {
      return <Navigate to="/plan-expired" replace />;
    }
    return children;
  }

  // 3. Active but onboarding not completed → only allow /onboarding
  if (!isOnboardingCompleted) {
    if (path !== "/onboarding") {
      return <Navigate to="/onboarding" replace />;
    }
    return children;
  }

  if (credential?.subscription_details?.credits_remaining <= 0) {
    if (path !== "/buy-credits") {
      return <Navigate to="/buy-credits" replace />;
    }
    return children;
  }

  // 4. If on a blocked route, but all conditions are satisfied → go to /home
  if (["/auth/login", "/onboarding", "/plan-expired"].includes(path)) {
    return <Navigate to="/home" replace />;
  }

  //5. If on a blocked route
  if (restrictedTo && restrictedTo.includes(userRole)) {
    return <PageNotFound />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
